/** Starter pack so the hub is not empty. Editable from Admin Controls. */

export const SEED_SETTINGS = {
  site_name: "DreamHome Journey",
  tagline: "A calm companion for the path home — not a marketplace.",
  support_intro:
    "Help for the desk you are on. Buyer and seller journeys stay on their own carpets.",
  marketing_blurb:
    "HomeSpec precision with DreamHome warmth. Agents and clients both leave with something usable.",
};

export const SEED_VISIBILITY = {
  buyer: true,
  seller: true,
  agent: true,
  broker: true,
  admin: true,
  vendors: true,
  board: true,
  events: true,
  pro: true,
  clients: true,
};

export const SEED_BLURBS = {
  pro: "Tools, associations, and templates for the office — kept apart from client checklists.",
  clients:
    "Moving, home prep, and escrow basics for buyers and sellers. Education, not a listing feed.",
  board: "A quiet board for meetings, training, and market notes. Public posts are visible to everyone.",
  events:
    "San Diego County first — local organizations through national conventions, opens, workshops, and expos. Southern California is the next expansion.",
};

export const SEED_ARTICLES = [
  {
    id: "art-buyer-faq",
    role: "buyer",
    section: "faq",
    title: "How does the Buyer’s Checklist work?",
    body: "You walk through location, home type, lot, exterior, interior, lifestyle, and accessibility at your own pace. Notes stay with you. Your agent sees a file they can use — not a public listing.",
  },
  {
    id: "art-buyer-features",
    role: "buyer",
    section: "features",
    title: "Checklists through license fields",
    body: "The buyer path covers discovery, specs, lifestyle, and a transaction checklist. License numbers you record are yours to keep; DreamHome Journey does not grant or verify a real-estate license.",
  },
  {
    id: "art-buyer-trouble",
    role: "buyer",
    section: "troubleshooting",
    title: "I do not see my notes after signing in",
    body: "Buyer notes live on the buyer journey only. Sign in as the same buyer on this device. Seller pages never share that state.",
  },
  {
    id: "art-buyer-practice",
    role: "buyer",
    section: "practices",
    title: "A calm pace",
    body: "Treat the checklist as a conversation with yourself, then with your agent. There is no race. Complete a section when it feels settled.",
  },
  {
    id: "art-seller-faq",
    role: "seller",
    section: "faq",
    title: "What is the Seller’s Checklist?",
    body: "A portfolio of features, condition, photos, and listing readiness. It is not a public listing site. Your agent uses it to understand the home you already know.",
  },
  {
    id: "art-seller-features",
    role: "seller",
    section: "features",
    title: "Photos, condition, and readiness",
    body: "Interior and exterior features, upgrades, condition notes, and a portfolio summary stay on the seller journey. Buyer specs never mix in.",
  },
  {
    id: "art-seller-trouble",
    role: "seller",
    section: "troubleshooting",
    title: "Photos feel slow to save",
    body: "Keep each photo reasonably sized. The desk compresses images locally. If a save fails, try one photo at a time.",
  },
  {
    id: "art-seller-practice",
    role: "seller",
    section: "practices",
    title: "Honest condition notes help everyone",
    body: "A clear condition note is a kindness to you, your agent, and a future buyer. Write what you know; you are not writing a legal disclosure form here.",
  },
  {
    id: "art-agent-faq",
    role: "agent",
    section: "faq",
    title: "Where do client messages live?",
    body: "Client Messaging is for the buyers and sellers assigned to you. Office Messaging is for colleagues. The two desks share one store and stay visually apart.",
  },
  {
    id: "art-agent-features",
    role: "agent",
    section: "features",
    title: "Files, documents, calendar, and reports",
    body: "File Packet, documents and photos, calendar, and communication reports sit on your desk. License fields on your profile auto-populate the Information & Resources footer. They are not a certification.",
  },
  {
    id: "art-agent-trouble",
    role: "agent",
    section: "troubleshooting",
    title: "A client does not appear in Client Manager",
    body: "Confirm they are assigned to you and that you are on the agent desk, not a broker All-Agents view. Buyer and seller files stay on their own journeys.",
  },
  {
    id: "art-agent-practice",
    role: "agent",
    section: "practices",
    title: "Write notes as if they will be archived",
    body: "Close and abandon flows save a communication report. Keep the tone you would want a broker to read later — calm, specific, and kind.",
  },
  {
    id: "art-broker-faq",
    role: "broker",
    section: "faq",
    title: "What can I see that an agent cannot?",
    body: "You can supervise every file in the brokerage. Agents still only see their assignments. Retention and archive views are on your desk.",
  },
  {
    id: "art-broker-features",
    role: "broker",
    section: "features",
    title: "Supervision without mixing journeys",
    body: "My Business and All Agents split your personal book from office-wide client files. Office Messaging stays apart from client threads.",
  },
  {
    id: "art-broker-trouble",
    role: "broker",
    section: "troubleshooting",
    title: "An agent seat looks inactive",
    body: "Check the agent’s status on the admin users desk if you have admin help, or ask them to sign in once on this device so the local prototype can see the account.",
  },
  {
    id: "art-broker-practice",
    role: "broker",
    section: "practices",
    title: "Retention is a habit, not a scramble",
    body: "Use the retention log when a file closes. Exports are for the office archive — not a public marketing packet.",
  },
  {
    id: "art-admin-faq",
    role: "admin",
    section: "faq",
    title: "What does the Admin desk manage?",
    body: "Suggestions, users, controls, messages, and the site map. Content for this marketing site is edited on REChecklist Controls. Admin does not fork client messaging.",
  },
  {
    id: "art-admin-features",
    role: "admin",
    section: "features",
    title: "Controls, vendors, events, and guides",
    body: "Admin Controls writes the @hub pack: articles, vendors, events, board posts, visibility. The User Guide A–Z is seeded in the pack and visible here.",
  },
  {
    id: "art-admin-trouble",
    role: "admin",
    section: "troubleshooting",
    title: "Journey does not show my Control edits",
    body: "Two origins do not share a browser store. Export the content pack from Controls and import on Journey when that tool is wired. Until then, both seed from the same pack.",
  },
  {
    id: "art-admin-practice",
    role: "admin",
    section: "practices",
    title: "Keep buyer and seller copy on separate carpets",
    body: "When you edit support articles, assign a single role. Do not write combined buyer/seller how-tos.",
  },
  {
    id: "art-buyer-tutorial",
    role: "buyer",
    section: "tutorials",
    title: "Walk one section, then rest",
    body: "Open the Buyer’s Checklist on REChecklist. Complete location or home type first. Notes stay in the companion sidebar. There is no race.",
  },
  {
    id: "art-buyer-links",
    role: "buyer",
    section: "links",
    title: "Where to go next",
    body: "REChecklist: start the buyer journey. DreamHomeJourney: User Guide (Checklists, Notes), Client vendors, Buyer support, Events calendar.",
  },
  {
    id: "art-seller-tutorial",
    role: "seller",
    section: "tutorials",
    title: "Portfolio before photos",
    body: "On the seller journey, capture features and condition first. Photos belong with the listing brief, not a public gallery.",
  },
  {
    id: "art-seller-links",
    role: "seller",
    section: "links",
    title: "Where to go next",
    body: "REChecklist: seller home. DreamHomeJourney: Seller support, Client vendors (staging, cleaning), User Guide (Documents & photos).",
  },
  {
    id: "art-agent-tutorial",
    role: "agent",
    section: "tutorials",
    title: "Open the file, then the thread",
    body: "From Client Manager, open the File Packet. Client Messaging stays next door. Office notes belong in Office Messaging.",
  },
  {
    id: "art-agent-links",
    role: "agent",
    section: "links",
    title: "Where to go next",
    body: "REChecklist: /agent dashboard, files, calendar, messages. DreamHomeJourney: Agent support, Guided Tour, Pro vendors, Events, Community board.",
  },
  {
    id: "art-broker-tutorial",
    role: "broker",
    section: "tutorials",
    title: "Supervise, then archive",
    body: "Use All Agents for office-wide files. Retention is a habit at close. Exports stay in the office archive.",
  },
  {
    id: "art-broker-links",
    role: "broker",
    section: "links",
    title: "Where to go next",
    body: "REChecklist: /broker desk, office messaging, retention. DreamHomeJourney: Broker support, Events (broker opens), Community, Pricing.",
  },
  {
    id: "art-admin-tutorial",
    role: "admin",
    section: "tutorials",
    title: "Edit Controls, then check Journey",
    body: "Vendors, events, articles, and visibility live on Admin Controls. The User Guide A–Z is shared code. Export the pack when you need a snapshot.",
  },
  {
    id: "art-admin-links",
    role: "admin",
    section: "links",
    title: "Where to go next",
    body: "REChecklist: /admin Controls, Messages, Suggestions, Users, Site Map. DreamHomeJourney: Admin support, User Guide, Vendors, Events, Community.",
  },
];

function v(id, audience, group, name, summary) {
  return {
    id,
    audience,
    group,
    name,
    summary,
    region: "San Diego County",
    url: "",
  };
}

export const SEED_VENDORS = [
  v("ven-pro-photo", "pro", "photographers", "Listing photography desk", "Placeholder studio for stills. Not a marketplace booth."),
  v("ven-pro-stage", "pro", "staging", "Quiet staging notes", "Sample staging partner for listing readiness. Policy stays with the broker."),
  v("ven-pro-reno", "pro", "renovation", "Renovation consult (sample)", "A placeholder for pre-list repairs — educational, not a bid wall."),
  v("ven-pro-clean", "pro", "cleaning_pro", "Turnover cleaning desk", "Sample crew for vacant homes. Confirm insurance with your office."),
  v("ven-pro-yard", "pro", "landscape_pro", "Curb-appeal yard notes", "Placeholder landscape contact for listing photos."),
  v("ven-pro-drone", "pro", "drone", "Aerial stills operator", "Sample drone operator. Follow local flight rules; we do not certify pilots."),
  v("ven-pro-vtour", "pro", "virtual_tour", "Walkthrough capture", "Placeholder virtual-tour provider for the file packet, not a public listing."),
  v("ven-pro-sign", "pro", "signs", "Yard sign install", "Sample sign installer for San Diego County offices."),
  v("ven-pro-lock", "pro", "lockbox", "Lockbox service note", "Placeholder lockbox logistics. Office policy still governs keys."),
  v("ven-pro-escrow", "pro", "escrow", "Escrow desk primer", "Educational escrow partner placeholder. Your officer still leads the file."),
  v("ven-pro-title", "pro", "title", "Title company primer", "Sample title contact for Southern California expansion."),
  v("ven-pro-assoc", "pro", "associations", "Local association desk", "County or regional association — meetings and member notes."),
  v("ven-pro-tools", "pro", "tools", "Office tools note", "Placeholder for CRM-adjacent tools. This site is not a marketplace booth."),
  v("ven-pro-svc", "pro", "services", "Professional services desk", "Sample office services — transaction coordination notes, not a hiring wall."),
  v("ven-client-edu", "client", "education", "Buyer & seller education", "Plain-language primers. Your agent still leads the file."),
  v("ven-client-home", "client", "home", "Home care notes", "Placeholder for post-close care. Educational only."),
  v("ven-pro-forms", "pro", "templates", "Office form templates", "Quiet templates for file packets. Not legal advice."),
  v("ven-client-movers", "client", "movers", "Move-week companion", "Sample mover list so closing week stays calm."),
  v("ven-client-clean", "client", "cleaners", "Move-out cleaners", "Placeholder cleaners for buyers and sellers."),
  v("ven-client-handy", "client", "handymen", "Punch-list handyman", "Sample handyman for small repairs before photos."),
  v("ven-client-paint", "client", "painters", "Neutral paint notes", "Placeholder painter for listing readiness."),
  v("ven-client-land", "client", "landscapers", "Simple yard care", "Sample landscaper for curb appeal."),
  v("ven-client-insp", "client", "inspectors", "Inspection primer", "Educational inspector note — hire through your agent."),
  v("ven-client-pest", "client", "pest", "Pest inspection note", "Placeholder pest-control primer."),
  v("ven-client-plumb", "client", "plumbers", "Plumbing check", "Sample plumber for pre-list or buyer walk-through questions."),
  v("ven-client-elec", "client", "electricians", "Electrical check", "Placeholder electrician for safety questions — not a bid board."),
  v("ven-client-move", "client", "moving", "Move-day checklist partner", "Home-prep list for the week of closing."),
  v("ven-client-escrow", "client", "escrow_edu", "Escrow basics primer", "Plain-language closing steps. Educational only."),
];

function evt(id, title, kind, scope, starts_on, location, summary, visibility = "public") {
  return {
    id,
    title,
    kind,
    scope,
    starts_on,
    starts_at: "09:00",
    location,
    summary,
    visibility,
    region: "San Diego County",
    url: "",
  };
}

export const SEED_EVENTS = [
  evt("evt-org", "Coastal board breakfast", "org_local", "local", "2026-09-08", "La Jolla community room", "A local organization breakfast. Educational networking."),
  evt("evt-county", "County housing forum", "county", "local", "2026-09-18", "County administration center", "San Diego County forum sample."),
  evt("evt-state", "State association gathering", "state_con", "state", "2026-10-12", "Sacramento convention hotel", "Placeholder state convention."),
  evt("evt-nat", "National leadership week", "national_con", "national", "2026-11-09", "National conference hotel", "Sample national convention."),
  evt("evt-bopen", "Broker open — coastal office", "broker_open", "local", "2026-09-22", "Office conference room", "Broker open-house note for the office.", "broker"),
  evt("evt-aopen", "Agent preview morning", "agent_open", "local", "2026-09-23", "Listing street (sample)", "Agent open placeholder. Not a public listing.", "agent"),
  evt("evt-net", "Mid-week mixer", "networking", "local", "2026-09-16", "Little Italy hall", "Calm mixer — not a race."),
  evt("evt-work", "File Packet workshop", "workshop", "regional", "2026-10-02", "Kearny Mesa classroom", "Workshop for new agents."),
  evt("evt-train", "Office huddle training", "training", "local", "2026-09-15", "Office training room", "First-Tuesday training sample."),
  evt("evt-vexpo", "Vendor expo (sample)", "vendor_expo", "regional", "2026-10-24", "Del Mar fairgrounds hall", "Pros and client-support booths. DreamHome is not a marketplace booth."),
  evt("evt-chamber", "County chamber breakfast", "chamber", "local", "2026-09-12", "Downtown chamber hall", "A local breakfast for members and guests."),
  evt("evt-expo", "Regional housing expo", "expo", "regional", "2026-10-03", "Convention center", "Builders and education booths."),
  evt("evt-summit", "Broker leadership summit", "summit", "national", "2026-11-06", "National conference hotel", "Retention and office culture.", "broker"),
];

export const SEED_BBS_POSTS = [
  {
    id: "bbs-1",
    category: "meetings",
    title: "Monthly office huddle — first Tuesday",
    body: "A standing note: first Tuesday is the quiet office huddle. Bring one file question, not a stack.",
    author_name: "Dev Admin",
    author_role: "admin",
    visibility: "public",
    created_at: "2026-08-04T16:00:00.000Z",
    flagged: false,
  },
  {
    id: "bbs-2",
    category: "training",
    title: "File Packet walkthrough for new agents",
    body: "New to the desk? The File Packet is the home for a client’s documents. Client Messaging stays next door.",
    author_name: "Dev Admin",
    author_role: "admin",
    visibility: "agent",
    created_at: "2026-08-10T17:30:00.000Z",
    flagged: false,
  },
  {
    id: "bbs-3",
    category: "market",
    title: "Late-summer inventory note",
    body: "A sample market note: inventory is a conversation with your clients, not a scoreboard. Share what you are seeing, calmly.",
    author_name: "Dev Admin",
    author_role: "admin",
    visibility: "public",
    created_at: "2026-08-18T14:00:00.000Z",
    flagged: false,
  },
];

export const SEED_BBS_COMMENTS = [
  {
    id: "cmt-1",
    post_id: "bbs-1",
    author_name: "Jordan Hale",
    author_role: "agent",
    body: "Noted — I will bring the Rivera file question only.",
    created_at: "2026-08-05T09:10:00.000Z",
  },
];
